import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';
import {
  DocumentCodeDto,
  DocumentReviewDetailsDto,
  UpdateEducatorDocumentFromReviewCommand,
  ReviewStatus,
} from 'src/shared/services/api.service';
import { ReviewStatusOptions } from '../constants';

@Component({
  selector: 'cert-document-review-educator-details',
  templateUrl: './document-review-educator-details.component.html',
  styles: ``,
  standalone: false,
})
export class DocumentReviewEducatorDetailsComponent implements OnChanges {
  @Input() documentTypeOptions!: DocumentCodeDto[];
  @Input() detailsForDocumentReview!: DocumentReviewDetailsDto;
  @Output() documentUpdateSave = new EventEmitter<UpdateEducatorDocumentFromReviewCommand>();

  reviewStatusOptions = ReviewStatusOptions;
  reviewStatus!: ReviewStatus;
  ReviewStatus = ReviewStatus;

  fileName = '';
  documentTypeSelections!: DocumentCodeDto[];

  isExpanded = true;

  errorEmitter = new EventEmitter<any>();

  get isRenamePending(): boolean {
    return !!this.detailsForDocumentReview?.pendingRenameDetail?.isInRenameQueue;
  }

  onSubmit() {
    // Prevent changing filename while a system rename is pending
    const effectiveFileName = this.isRenamePending ? this.detailsForDocumentReview.fileName : this.fileName;

    const command: UpdateEducatorDocumentFromReviewCommand = {
      personDocumentId: this.detailsForDocumentReview.personDocumentId,
      fileName: effectiveFileName,
      reviewStatus: this.reviewStatus,
      reviewComments: this.detailsForDocumentReview.reviewComments,
      documentCodeIds: this.documentTypeSelections.map((x) => x.documentCodeId!),
    };
    this.documentUpdateSave.emit(command);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.detailsForDocumentReview && this.detailsForDocumentReview) {
      this.fileName = this.detailsForDocumentReview.fileName;
      this.reviewStatus = this.detailsForDocumentReview.reviewStatus!;
      this.documentTypeSelections = this.documentTypeOptions.filter((option) =>
        this.detailsForDocumentReview.documentCodeIds.includes(option.documentCodeId!),
      );
    }
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  get reviewBadgeClass() {
    return {
      'badge-success': this.reviewStatus == ReviewStatus.Reviewed,
      'badge-warning': this.reviewStatus == ReviewStatus.PendingReview,
      'badge-danger': this.reviewStatus == ReviewStatus.Rejected,
    };
  }
}
